import React, { FC } from 'react';
import { Spin as BaseSpin } from 'antd';

interface ISpinProps {
  className?: string;
  spinning?: boolean;
  style?: React.CSSProperties;
  size?: 'small' | 'default' | 'large';
  tip?: string;
  delay?: number;
}

export const Spin: FC<ISpinProps> = props => {
  return <BaseSpin {...props} />;
};

export default Spin;
